import * as types from '../mutation-types'
import {api} from '@/api'
import Vue from 'vue'
import { Store } from 'vuex';
//通用模块状态控制
const userModule = {
    state: {
      liner:[],
      department:[],
      brandCategory:[]
    },

    //激发事件改变state
    mutations: {
      setLiner(state, option){//设置线别
        state.liner=option
      },
      setDepartment(state, option){//设置部门
        state.department=option
      },
      setBrandCategory(state, option){//设置品牌品类
        state.brandCategory=option
      }
    },

    // 异步操作拿远程数据,然后提交事件
    actions: {
      getLinerTree({commit, state}, params){
        return new Promise((resolve,reject)=>{
          api.user.getLineConfigureTreeListToUser().then(res => {
            if(res.status){
              commit("setLiner", res.data) ;
            }
            resolve()
          })
        }).catch(err=>{
            reject(err)
        })
      },
      getDepartmentTree({commit, state}, params){
        return new Promise((resolve,reject)=>{
          api.user.getDepartmentConfigureTreeListToUser().then(res => {
            if(res.status){
              commit("setDepartment", res.data) ;
            }
            resolve()
          })
        }).catch(err=>{
            reject(err)
        })
      },
      getBrandCategory({commit, state}, params){
        return new Promise((resolve,reject)=>{
          api.user.getBrandConfigureListToUser(params).then(res => {
            if(res.status){
              commit("setBrandCategory", res.data) ;
            }
            resolve()
          })
        }).catch(err=>{
            reject(err)
        })
      },
    },

    //频繁通用计算
    getters: {

    }
}

export default userModule;
